import { Component, effect, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../Navigation/Services/navigation.service';
import { MsgService } from '../../Shared/Services/msg.service';
import { AvBreadcrumbComponent } from '../../Shared/Components/av-breadcrumb/av-breadcrumb.component';
import { ShowUserFacade } from '../../../Facades/Intune/show-user.facade';
import { isUUID } from '../../Shared/Utils/validation.utils';
import { UserActionsComponent } from '../Components/partials/user-actions/user-actions.component';
import { AvLoadingItemComponent } from '../../Shared/Components/av-loading-item/av-loading-item.component';

@Component({
  selector: 'app-user',
  imports: [RouterOutlet, AvBreadcrumbComponent, UserActionsComponent, AvLoadingItemComponent
    
  ],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent implements OnInit, OnDestroy {
  private _navigationService = inject(NavigationService);
  private _facade = inject(ShowUserFacade);
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _msgService = inject(MsgService);
  private _translate = inject(TranslateService);

  private _paramSub?: Subscription;

  readonly user = this._facade.user;
  fetchUserEffect = effect(() => {
    this.handleFetchError();
  });

  ngOnInit() {
    this._navigationService.setSecondaryView('users/:id');
    this.fetchUser();
  }

  ngOnDestroy() {
    this._paramSub?.unsubscribe();
    this._navigationService.clearSecondaryView();
  }

  private fetchUser() {
    this._paramSub = this._route.paramMap
      .pipe(filter((params) => params.has('id')))
      .subscribe((params) => {
        const userId = params.get('id');
        if (!userId || !isUUID(userId)) {
          this._router.navigate(['/users']);
          this._translate.get('shared.general.errors.invalid_user_id').subscribe((msg) =>
            this._msgService.showSnackBar(msg, { type: 'error' }));
          return;
        }
        this._facade.setUserId(userId);
      });
  }

  private handleFetchError() {
    if (this._facade.userError()) {
      this._router.navigate(['/users']);
    }
    return true;
  }
}
